/// JTF3-PRO-added-AB-22-04-13



'use strict'

jQuery(document).ready(function($) {
	console.log('JTF FORMSTACK V1.0.8');
	/**
	 * FORMSTACK HIJACKER
	 *
	 * When a Formstack form is posted (IE when a form with the class .fsForm is
	 * posted) we hijack the submit action using JS, prevent the default post
	 * action (which would take us off the website) and instead don't redirect
	 * but post the data anyway. This way we can do other actions after form
	 * submission without having to reset the page. YAY!
	 *
	 * @return boolean success message
	 */

	// Needs document on submit so we can hijack forms in a child theme, otherwise the element gets looked for by this script before it's rendered - must be a weird thing to do with the order scripts are loaded in child themes.
	$(document).on('submit', '.fsForm', function(e) {
		// Stop the default form action (IE the refresh and navigation out of
		// the page)
		e.preventDefault();
		// console.log('hijacking request..');
		// AJAX request to
		// /wp-content/themes/JTF/functions/formstack_post_request.php - we pass
		// in the form data to it with encoded JSON (so it keeps it as a string)
		// and then decode it and post it on the other end.

		// set self to this because this context will become the post content inside the ajax call.
		var self = $(this);
		var pageId = '';
		if ($(this).parents('.formstack__protectedform').length > 0) {
			pageId = $(this).parents('.formstack__protectedform').attr('data-id');
		}
		
		if ($(this).parents('.formstack__securedownload').length > 0) {
			// console.log('found formstack__securedownload')
			pageId = $(this).parents('.formstack__securedownload').attr('data-id');
		} else {
			// console.log('havent found formstack__securedownload')
		}

		$.ajax({
			type: 'POST',
			url: '/wp-content/themes/JTF/functions/formstack_post_request.php',
			data: {
				data: JSON.stringify($(this).serialize())
			},
			dataType: 'JSON',
			success: function(data) {
				/**
				 * Technically we'll always get a success from FS as even with a data failure they return a 200 (since what we actually get returned from them is a page of HTML, so it's neither a success or failure), so to distinguish a data error we get the PHP page (formstack_post_request) to return a boolean based on the content of the HTML FS returned.
				 */
				if ( data == false ) {
					// Create ghost element that we can load the success message into
					var ghostFailure = $('<div/>',
						{
							'class': 'formstack__ghostcontainer'
						}
					);
					
					// Check to see if the failure message HTML exists in the child theme, if it doesn't use the generic one from JTF parent. This lets us override the failure message per project if we need something more specific.
					$.ajax({
						url: '/wp-content/themes/JTF-child/functions/formstack_failure.php',
						type: 'HEAD',
						error: function() {
							console.log('formstack failure in parent');
							ghostFailure.load( "/wp-content/themes/JTF/functions/formstack_failure.php" );
						},
						success: function() {
							console.log('formstack failure in child');
							ghostFailure.load( "/wp-content/themes/JTF-child/functions/formstack_failure.php" );
						}
					});
					// console.log('Formstack response ERROR');
					self.before(ghostFailure);
				} else {
					/**
					 * For protected forms, requires the wrapping container of the Formstack script to have the following attributes
					 * class: "formstack__protectedform"
					 * data-id: wordpress page id. (get_the_id())
					 * This is used so that when we submit a protected form it stores a cookie for the protected page then forces a refresh which will then bypass the form because we've set a cookie.
					*/
					if ( self.parents('.formstack__protectedform').length > 0 ) {
						// alert('is protected form');
						document.cookie = "gated_access_" + pageId + "=1; expires=Tue, 19 Jan 2050 03:14:07 GMT";
						document.cookie = "wordpress_logged_in=true";
						location.reload();
					} else {
						console.log('no formstack__protectedform');
					}
					
					// THIS IS LEGACY, REMOVE THIS ONCE WE'VE ADOPTED GUTENBERG COMPLETELY
					if ( self.parents('.formstack__securedownload').length > 0 ) {
						document.cookie = "secure_download_" + pageId + "=1; expires=Tue, 19 Jan 2060 03:14:07 GMT";
						document.cookie = "wordpress_logged_in=true";
						location.reload();
					} else {
						// console.log('no formstack__securedownload');
					}
					
					// GUTENBERG SECURE FILE
					// ADDED JUNE 2021 - JD
					if ( self.parents('.jtf__securefileblock--embed').length > 0 ) {
						let parent = self.parents('.jtf__securefileblock--embed');
						let pageId = parent.attr('data-pageId')
						let fileId = parent.attr('data-id')
						
						document.cookie = "secure_download_" + pageId + "=1; expires=Tue, 19 Jan 2090 03:14:07 GMT";
						document.cookie = "wordpress_logged_in=true";
						location.reload();
					}
					
					
					// Create ghost element that we can load the success message into
					var ghostConfirmation = $('<div/>',
						{
							'class': 'formstack__ghostcontainer'
						}
					);
					// Check to see if the confirmation message HTML exists in the child theme, if it doesn't use the generic one from JTF parent. This lets us override the confirmatin message per project if we need something more specific.
					$.ajax({
						url: '/wp-content/themes/JTF-child/functions/formstack_confirmation.php',
						type: 'POST',
						error: function() {
							console.log('formstack confirmation in parent');
							ghostConfirmation.load( "/wp-content/themes/JTF/functions/formstack_confirmation.php" );
						},
						success: function() {
							const thisId = $('body').attr('data-id');
							console.log('formstack confirmation in child');
							ghostConfirmation.load( "/wp-content/themes/JTF-child/functions/formstack_confirmation.php?postid=" + thisId);
						}
					});

					// Append success message into container
					self.before(ghostConfirmation);
				}
				self.remove();
			},
			error: function(data) {
				console.log('error', data);
			}
		});
	})
});

